module.exports = __webpack_public_path__ + "static/img/HomePlayingDark@2x.4c45903.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/UI_mock/2x/HomePlayingDark@2x.png
// module id = n5H7
// module chunks = 1